<template>
  {{ props.value !== undefined ? byteValueNumberFormatter.format(props.value) : '' }}
</template>

<script lang="ts" setup>
const props = defineProps<{
  value?: number
}>()

const byteValueNumberFormatter = Intl.NumberFormat('en', {
  notation: 'compact',
  style: 'unit',
  unit: 'byte',
  unitDisplay: 'narrow'
})
</script>
